import React, { Component } from 'react';
import {setAndGetAttributes} from './FormInputFunctions';
import Wrp from "../../hoc/Wrp/Wrp";
import { formFieldsAttributes } from '../FormBuilder/FormBuilderFunctions/FieldProps';

class Decimal extends Component {

  fieldOnChangeHandler(e){
    const {changeHandler,isAllowNegative} = this.props;
    let attr = setAndGetAttributes(this.props);
    const negCheckExp  = (isAllowNegative===false)?'':'[-]?';
    const decimalPlaces = (attr.decimal===0)?2:Number(attr.decimal);
    // let regExp = '^'+negCheckExp+'(\[0-9]+)?([\.])?(\[0-9]{1,'+decimalPlaces+'})?([\%])?$'
    let maxLength = (this.props.attributes.maxLength!==undefined)?this.props.attributes.maxLength:5;
    let maxDecimalLength =(this.props.attributes.maxLength)? this.props.attributes.decimal:2;
    //let regExp = new RegExp(`^`+negCheckExp+`(\\d{0,${maxLength}})(\\.\\d{0,${maxDecimalLength}})?([\%])?$`);
    let regExp = new RegExp(`^`+negCheckExp+`(\\d{0,${maxLength}})(\\.\\d{0,${maxDecimalLength}})?([])?$`);
    // console.log('regExp',regExp,negCheckExp,attr.decimal);
    // regExp = new RegExp(regExp);
    let input_value = e.target.value.replace(/(\.\%)/,''); 
    if((input_value.search(/^[0]{1,}[\d]/)!==-1 || // takes care of leading zeroes
      input_value.search(regExp)===-1) &&  //main pattern
      input_value!==''){
      e.target.value  = (this.input_prev_value!==undefined)?this.input_prev_value:'';
      changeHandler(e.target.value);
    }else {  
        e.target.value = (input_value!==undefined)?input_value:'';
        this.input_prev_value = e.target.value;
        changeHandler(e.target.value);
    }
  } 

  render() {
    const {value} = this.props;
    let attr = setAndGetAttributes(this.props);
    const attrii = formFieldsAttributes(
      {...this.props});
    return (
      <Wrp>
        <input 
          type="text"
          {...attr}
          onChange={e=>this.fieldOnChangeHandler(e)}
          value={value}          
          {...attrii.fieldAttributes}
        />
      </Wrp>        
    );
  }
}

Decimal.defaultProps = {
  isMandatory:false,
  decimal:9,
  isAllowNegative:true,
  className: 'form-control'
}

export default Decimal;